import settings from '@/settings'

let PegarCodigos = (headers) => {
  return fetch(`${settings.apetrusApi}/codigospromocionais/porposto/${null}/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let inserir = (data, headers) => {
  return fetch(`${settings.apetrusApi}/codigospromocionais/`, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

let cancelar = (id, headers) => {
  return fetch(`${settings.apetrusApi}/codigospromocionais/${id}/`, {
    method: 'DELETE',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let atualizar = (id, data, headers) => {
  return fetch(`${settings.apetrusApi}/codigospromocionais/${id}/`, {
    method: 'PUT',
    mode: 'cors',
    cache: 'default',
    body: JSON.stringify(data),
    headers: headers
  })
}

let vinculo = (headers, data) => {
  // Vincula ou desvincula um posto ou rede
  return fetch(`${settings.apetrusApi}/codigospromocionais/vinculo/`, {
    method: data.method,
    mode: 'cors',
    cache: 'default',
    body: JSON.stringify(data),
    headers: headers
  })
}

export default {
  PegarCodigos,
  inserir,
  cancelar,
  atualizar,
  vinculo
}
